class ModuleLoader {
    constructor() {
        this.loaded = new WeakMap();
        this.imported = {};
        this.observer = new IntersectionObserver(
            (entries, observer) => this.onVisible(entries, observer),
            { root: null, rootMargin: '0px', threshold: 0 },
        );
        this.update();
    }

    async update() {
        const els = [...document.querySelectorAll('*[data-esmodule]')];
        const modules = els.filter((el) => !this.loaded.has(el));
        for (const module of modules) {
            await this.load(module);
        }
    }

    async load(el) {
        const { esmodule } = el.dataset;
        const Module = await this.get(esmodule);
        const ModuleClass = Module?.default;

        if (ModuleClass) {
            this.loaded.set(el, new ModuleClass(el));
        } else {
            this.loaded.set(el, true);
        }

        el.classList.remove('pre-animation');
        el.classList.add('esmodule-loaded');
        this.onLoad(el);
    }

    onLoad(el) {
        if (el.dataset.analyticsOnLoad) {
            const data = this.json(el.dataset.analyticsOnLoad);
            dataLayer?.push(data);
        }
        if (el.dataset.analyticsOnVisible || el.dataset.esObserver == 'true') {
            this.observer.observe(el);
        }
    }

    onVisible(entries, observer) {
        entries.forEach((entry) => {
            if(entry.isIntersecting) {
                const el = entry.target;
                if (el.dataset.analyticsOnVisible) {
                    const data = this.json(el.dataset.analyticsOnVisible);
                    dataLayer?.push(data);
                }
                el.dispatchEvent(new CustomEvent('visible'));
                this.observer.unobserve(el);
            }
        });
    }

    json(data) {
        if(data){ try { return JSON.parse(data.replace(/\'/g, '\"')); } catch { return null; } }
    }

    async get(esmodule) {
        if (!this.imported[esmodule]) {
            this.imported[esmodule] = await import(/* webpackChunkName: '[request]' */ `./${esmodule}/index`);;
        }
        return this.imported[esmodule];
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.HONDA.ModuleLoader = new ModuleLoader();
});
